import { faCircleChevronLeft, faCircleChevronRight, faHouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux';
import { getPOIList, getPOIViewData } from "../../../redux/actions/nbhd/nbhd";
import { RESET_NEW_POI, RESET_POI_VIEW_DATA } from "../../../redux/actionTypes/actionsTypes";
import { NewPoiState } from "../../../redux/reducers/getNBHDReducer/getNewPoisReducer";
import { POIViewDataState } from "../../../redux/reducers/getNBHDReducer/getPOIViewDataReducer";
import { RootState } from "../../../redux/reducers/root";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import DownloadPoiProfile from "../DownloadPoiProfile/DownloadPoiProfile";
import "./ViewPOI.css";
import PoiConfirmationModal from "../PoiReportConfirmation/PoiReportConfirmation";
import { changeIsCloseable, changeModalContent, changeModalState } from "../../../redux/actions/modal/modal";

export interface ViewPOIProp {
    handleViewChange: (e) => void;
    setReportLoading: (e) => void;
}

export default function ViewPOI(props: ViewPOIProp) {
    const currentProperty = useSelector((state: RootState) => state.propertyListReducer.currentProperty);
    const userProfileId = window.localStorage.getItem("userProfileId");

    const poiViewDataState = useSelector((state: RootState) => state.NBHDReducer.POIViewData as POIViewDataState);
    const loading: boolean = poiViewDataState['loading'];

    const newPoiState = useSelector((state: RootState) => state.NBHDReducer.NewPoi as NewPoiState);

    const { t, i18n } = useTranslation(["nbhd"]);
    const dispatch = useDispatch();

    const [dispatched, setDispatched] = useState(false);
    const [lirowHeights, setLirowHeights] = useState({});
    const [xVal, setXVal] = useState(0);

    const [newPoisSent, setNewPoisSent] = useState(false);

    const [acceptedNewPois, setAcceptedNewPoi] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const move = (e, diff: number) => {
        if (poiViewDataState.poiprops.length === 0) {
            return;
        }

        const poireportcontainer = document.getElementsByClassName("poi-report-container")[0];
        const swiperwrapper = document.getElementsByClassName("swiper-wrapper")[0];
        const scrollWidth = swiperwrapper.scrollWidth;
        const poiWidth = scrollWidth / poiViewDataState.poiprops.length;
        let width = 0;
        if (scrollWidth >= poireportcontainer.clientWidth) {
            width = scrollWidth - poiWidth + 1;
        }

        const leftPos = 0;
        const rightXPos = -width;

        let newXVal = xVal + (diff * poiWidth);
        if (newXVal > leftPos || newXVal <= rightXPos) {
            newXVal = 0;
        }
        swiperwrapper.style.transform = `translate(${newXVal}px)`;
        setXVal(newXVal);
    }
    useEffect(() => {
        if (loading) {
            props.setReportLoading(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading])

    const cancelPoiLoad = () => {
        dispatch({type: RESET_NEW_POI});
        if(!dispatched) {
            props.handleViewChange("MAP");
        }        
        setModalOpen(false);
        dispatch(changeModalState("modal-dismiss"));
        dispatch(changeModalContent(<></>));
        setAcceptedNewPoi(false);
        
    }

    const confirmPoiLoad = () => {
        setAcceptedNewPoi(true);
        setModalOpen(false);
        dispatch(changeModalState("modal-dismiss"));
        dispatch(changeModalContent(<></>));
        setDispatched(false);
        dispatch({ type: RESET_POI_VIEW_DATA });
    }

    const openModal = () => {
        dispatch(changeIsCloseable(false));
        dispatch(changeModalContent(
            <PoiConfirmationModal
                onOk={() => {confirmPoiLoad()}} 
                onCancel={() => cancelPoiLoad()} 
            />,
            `${t("nbhd.Map-Nav.report-1")} ${t("nbhd.Map-Nav.report-2")}`,
            "ariaLabelText"));

        dispatch(changeModalState("modal-fade-in"));
        setModalOpen(true);
    }
 
    useEffect(() => {
        if (!dispatched && !loading && poiViewDataState.fields.length === 0) {
            const payload = {
                "user": userProfileId,
                "lang": i18n.language,
                "roll": currentProperty.currentProperty,
                "new_pois": newPoiState.newPoi,
                "owner_type": currentProperty["currentOwnerType"]
            };

            dispatch({ type: RESET_POI_VIEW_DATA })
            setLirowHeights({})
            
            if (newPoiState.newPoi.length > 0) {
                if (!acceptedNewPois && !modalOpen) {
                    // Show confirmation modal
                    openModal();
                } else if(acceptedNewPois) {
                    setNewPoisSent(true);
                    dispatch(getPOIViewData(payload));
                    setDispatched(true);
                }
            } else {
                dispatch(getPOIViewData(payload));
                setDispatched(true);
            }



        }
        else if (poiViewDataState.fields.length > 0 && Object.keys(lirowHeights).length === 0) {
            // DISPATCHED DATA HAS BEEN OBTAINED
            if (newPoiState.newPoi.length > 0 && !loading && dispatched) {
                if (newPoisSent) {
                    // we have a new poi
                    dispatch(getPOIList(userProfileId, currentProperty["currentProperty"], currentProperty["currentOwnerType"]));
                    dispatch({ type: RESET_NEW_POI });
                    setNewPoisSent(false);
                } else {
                    openModal();
                }
            }
        }
        // eslint-disable-next-line
    }, [poiViewDataState, dispatched, loading, currentProperty, dispatch, i18n.language, userProfileId, newPoiState, lirowHeights, newPoisSent])



    return (
        <>
            <AmpLoadingSpinner loading={loading}>
                <div className="report-container-main nopadding">
                    <div className="report-view-container">
                        <div className="report-container return-top-map-btn" onClick={() => props.handleViewChange('MAP')}>
                            <span>{t("nbhd.POI.return-to-map-view")}</span>
                        </div>
                        <div className="scroll-v">
                            <ul className="field-names">
                                <li className="rvHead"></li>
                                {
                                    poiViewDataState.fields.map((field, key) => {
                                        return <li className="lirow" key={field} name={field} style={{ height: field in lirowHeights ? lirowHeights[field] : "" }}>{field}</li>
                                    })
                                }
                            </ul> {/* field-names */}

                            <ul className="swiper-slide my-property-info">
                                {
                                    poiViewDataState.fields.length > 0 ?
                                        <li className="rvHead">
                                            <FontAwesomeIcon icon={faHouse} size="3x" color="#a3a3a396" />
                                        </li>
                                        :
                                        <></>
                                }
                                {
                                    poiViewDataState.fields.map((field, key) => {

                                        if (field === "Property Profiles") {
                                            return <li className="lirow" key={field} name={field} >
                                                <DownloadPoiProfile isParent={true} />
                                            </li>
                                        }
                                        else if (poiViewDataState.subprop[field] === "") {
                                            return <li className="lirow" key={field} name={field}>&nbsp;</li>
                                        } else {
                                            return <li className="lirow" key={field} name={field}>{poiViewDataState.subprop[field]}</li>
                                        }
                                    })
                                }
                            </ul>{/* swiper-slide my-property-info */}

                            <div className="poi-report-window">
                                <div className="poi-report-container swiper-container swiper-container-h swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">
                                    <div className="swiper-wrapper">
                                        {
                                            poiViewDataState.poiprops.map((poiprop, propkey) => {
                                                return (
                                                    <ul key={propkey} className="swiper-slide">
                                                        <li className="rvHead">
                                                            <FontAwesomeIcon icon={faHouse} size="3x" color="#a3a3a396" />
                                                        </li>
                                                        {
                                                            poiViewDataState.fields.map((field, key) => {

                                                                if (field === "Property Profiles") {
                                                                    return <li className="lirow" key={field} name={field} >
                                                                        <DownloadPoiProfile poiRoll={poiprop["Roll Number"]} />
                                                                    </li>
                                                                } else if (poiprop[field] === "") {
                                                                    return <li className="lirow" key={field} name={field}>&nbsp;</li>
                                                                } else {
                                                                    return <li className="lirow" key={field} name={field} >{poiprop[field]}</li>
                                                                }
                                                            })
                                                        }
                                                    </ul>
                                                )
                                            })
                                        }
                                        <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                                    </div>{/* swiper-wrapper */}
                                </div>{/* poi-report-container swiper-container swiper-container-h swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events */}
                            </div>{/* poi-report-window */}

                        </div> {/* scroll-v */}
                    </div> {/* report-view-container */}

                    {
                        poiViewDataState.poiprops.length > 1 ?
                            (
                                <>
                                    <div className="scroll-button left" onClick={(e) => move(e, 1)}>
                                        <FontAwesomeIcon icon={faCircleChevronLeft} size="1x" />
                                    </div>
                                    <div className="scroll-button right" onClick={(e) => move(e, -1)}>
                                        <FontAwesomeIcon icon={faCircleChevronRight} size="1x" />
                                    </div>
                                </>
                            )
                            :
                            <></>
                    }
                </div>{/* report-container-main */}
            </AmpLoadingSpinner>
        </>
    );
}